module.exports = __webpack_public_path__ + "static/media/small-add.36992f45.svg";